import React from 'react';
import { SquareBadge, StepItem } from '../../../components/Step';
import { Container, Ul, P, StepCopy, StepContentWrapper, Subtitle, Title, Left, LeftContent, Right } from './styles';

const Process = () => (
    <Container>
        <Left>
            <LeftContent>
                <Title>We Provide a Turnkey Solution</Title>
                <Subtitle>
                    Solvana handles every step of the process to Go Solar with our team of dedicated professionals who will seamlessly move your project from design to completion.
                </Subtitle>
            </LeftContent>
        </Left>

        <Right>
            <Ul>
                <StepItem
                    title="System Design"
                    icon={<SquareBadge size="15px">1</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                Our experts help you choose a custom system that is right for you to maximize the solar value and your financial savings. With Solvana’s assistance, you select your system type, modules, battery, financing, and more. Then we make it happen.
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>

                <StepItem
                    title="Site Visit & Engineering"
                    icon={<SquareBadge size="15px">2</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                After choosing a solar-generating system design that meets your needs, we visit your location to conduct a Site Survey. Our engineers take the results from the Site Survey and prepare a Plan Set, which we submit to you for your approval.
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>

                <StepItem
                    title="Permits & Approvals"
                    icon={<SquareBadge size="15px">3</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                States, counties, and municipalities all have different laws, rules, and regulations governing solar-generating system installations. Once you approve the design and location of the modules, Solvana’s permit processing team handles all the time-sensitive payments, submits all permit applications, and coordinates with our operations team so that the many moving parts stay in sync.
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>

                <StepItem
                    title="Installation"
                    icon={<SquareBadge size="15px">4</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                Once the permits are approved, Solvana’s licensed and insured operations team will call you to schedule the installation of the solar modules, mounting structures, electrical components, inverters, batteries, monitoring systems, and more.
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>

                <StepItem
                    title="Inspections"
                    icon={<SquareBadge size="15px">5</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                Municipal or County Zoning and Construction Code Offices (Authorities Having Jurisdiction - AHJ), the State, and the Utility Company require inspections throughout the installation process. Solvana’s operation team coordinates and manages all of the inspections to ensure everything is compliant, efficient, and safe.
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>

                <StepItem
                    title="Power On"
                    icon={<SquareBadge size="15px">6</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                After we fulfill the inspections, the utility company swaps your electric meter and provides Permission to Operate. At this point, you can use your solar-generating system to generate your electricity and to monitor your solar electrical production.
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>

                <StepItem
                    title="Redeem Benefits"
                    icon={<SquareBadge size="15px">7</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                After receiving Permission to Operate and turning on your solar-generating system, our permit processing team submits the final incentive paperwork so you can begin receiving your benefits.  Meanwhile, you will still be producing clean energy and reaping the electric savings and other financial benefits.
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>

            </Ul>
        </Right>
    </Container>
);

export default Process;



// WEBPACK FOOTER //
// ./src/containers/Home/Process/Process.js